export function csrfToken() {
  if (typeof document === "undefined") return ""

  return document.querySelector("meta[name='csrf-token']")?.content || ""
}

export function HiddenField({ name, value }) {
  return <input type="hidden" name={name} defaultValue={value} />
}

export function MethodField({ method }) {
  return <HiddenField name="_method" value={method} />
}
